import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { paramCase } from 'change-case';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { BlockOutlined, CopyAll, TaskAltOutlined } from '@material-ui/icons';
// material
import { useTheme } from '@material-ui/core/styles';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, } from '@material-ui/core';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import ConfirmationPopup from '../../official-request/ConfirmationPopup'
// ----------------------------------------------------------------------

ProductsMenu.propTypes = {
  onDelete: PropTypes.func,
  userName: PropTypes.string,
  id: PropTypes.number,
  status: PropTypes.number
};

export default function ProductsMenu({ onDelete, userName, id, status,setRefresh,selectedTab,timeAndMaterial, handleMove }) {
  const ref = useRef(null);
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false);
  const [openDeletePop,setOpenDeletePop] =useState(false)
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const duplicateThrottleRef = useRef(false);
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const [duplicateDisabled, setDuplicateDisabled] = useState(false);
  const [moveTarget, setMoveTarget] = useState(null);

  const changeStatus = async (prodId, prodStatus) => {
    try {
      let id = prodId;
      let status = prodStatus;
      console.log("id-----", id, " status-----------", status)
      let response = await axios.post((`${REST_API_END_POINT}product/delete-product?id=${id}&status=${status}`),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
      // console.log("response-----------------", response.data);
      if (response.data.status === 1 || response.data.status === 2 || response.data.status === 4) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        navigate(PATH_DASHBOARD.products.main, { state: { data: true } });
      }
      else if (response.data.status === 0 || response.data.status === 3 || response.data.status === 5 || response.data.status === 500) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        navigate(PATH_DASHBOARD.products.main, { state: { data: true } });
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Error.........!", { variant: 'error' });
        navigate(PATH_DASHBOARD.products.main, { state: { data: true } });
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuItemClick = async (id, newStatus) => {
    setIsOpen(false)
    setOpenDeletePop(false);
    await changeStatus(id, newStatus);
    navigate(PATH_DASHBOARD.products.main);
  }

  const handleDuplicate = async () => {
    if (duplicateThrottleRef.current) return;
  
    // Lock future calls
    duplicateThrottleRef.current = true;
    setDuplicateDisabled(true);
    setIsOpen(false);
  
    try {
      const res = await axios.post(`${REST_API_END_POINT}product/duplicate`, { id });
  
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRefresh(true);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong!', { variant: 'error' });
    } finally {
      // Unlock after 1 second (throttle time)
      setTimeout(() => {
        duplicateThrottleRef.current = false;
        setDuplicateDisabled(false);
      }, 1000);
    }
  };
  

  // const handleDuplicate = async () => {
  //   if (isDuplicatingRef.current) return;
  
  //   isDuplicatingRef.current = true;
  //   setDuplicateDisabled(true);  // 🔒 Disable menu item
  //   setIsOpen(false);            // 🔒 Close menu
  
  //   try {
  //     const res = await axios.post(`${REST_API_END_POINT}product/duplicate`, { id });
  
  //     if (res.data.status === 1) {
  //       enqueueSnackbar(res.data.message, { variant: 'success' });
  //       setRefresh(true);
  //     } else {
  //       enqueueSnackbar(res.data.message, { variant: 'error' });
  //     }
  //   } catch (error) {
  //     enqueueSnackbar('Something went wrong!', { variant: 'error' });
  //   } finally {
  //     isDuplicatingRef.current = false;
  //     setDuplicateDisabled(false); // 🔓 Re-enable after response
  //   }
  // };
  
  
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 'fit-width', maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >

        {
              selectedTab==="time_and_material"?
              <MenuItem
              disabled={explodedPermissions?.some(permission => ['Delete Catalog'].includes(permission)) ? false : true}
              onClick={()=>{setOpenDeletePop(true),setIsOpen(false)}}>
                  <ListItemIcon>
                  <Icon icon={trash2Outline} width={24} height={24} />
                  </ListItemIcon>
                  <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
                :
                <>
       

        <MenuItem
          disabled={explodedPermissions?.some(permission => ['Edit Catalog'].includes(permission)) ? false : true}
          // component={RouterLink}
          onClick={()=>{
            if (status !== 1) {
              enqueueSnackbar('Inactive catalog. Please activate to edit.', { variant: 'warning' });
              setIsOpen(false);
              return;
            }
            // navigate(`${PATH_DASHBOARD.products.edit}?id=${id}/edit`,{
            //   state:{inhouse:selectedTab==='in_house'?true:false,
            //     timeAndMaterial: selectedTab === 'time_and_material' ? true : false,
            //      edit:id,
            //      isTrafficCatalog:selectedTab == 'traffic_catalog'? true : false
            //   },
            // })
            navigate(`${PATH_DASHBOARD.products.edit}?id=${id}/edit`, {
              state: {
                inhouse: selectedTab === 'in_house' ? true
                  : selectedTab === 'in_stock_catalog' ? 4
                  : selectedTab === 'client_owned_catalog' ? 5
                  : selectedTab === 'split_catalog' ? 6
                    : false,
                timeAndMaterial: selectedTab === 'time_and_material',
                edit: id,
                isTrafficCatalog: selectedTab === 'traffic_catalog',
                selectedTab: selectedTab
              }
            });
          }}
          // to={`${PATH_DASHBOARD.products.edit}?id=${id}/edit`}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          disabled={duplicateDisabled}
          onClick={handleDuplicate}
       >
         <ListItemIcon>
         <CopyAll icon={CopyAll} width={24} height={24} />
         </ListItemIcon>
         <ListItemText primary="Duplicate" primaryTypographyProps={{ variant: 'body2' }} />
       </MenuItem>
        {status === 1 ? (
          <MenuItem
          disabled={explodedPermissions?.some(permission => ['Activate/Deactivate Catalog'].includes(permission)) ? false : true}
          onClick={() => handleMenuItemClick(id, 0)}
          >
            <ListItemIcon>
              <BlockOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Deactivate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ) : (
          <MenuItem
          disabled={explodedPermissions?.some(permission => ['Activate/Deactivate Catalog'].includes(permission)) ? false : true}
          onClick={() => handleMenuItemClick(id, 1)}
          >
            <ListItemIcon>
              <TaskAltOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Activate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        <MenuItem
        disabled={explodedPermissions?.some(permission => ['Delete Catalog'].includes(permission)) ? false : true}
        onClick={()=>{setOpenDeletePop(true),setIsOpen(false)}}>
            <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>

          {/* Move options - Only show if not time_and_material or inactive_catalogs */}
          {['in_house', 'in_stock_catalog', 'sub_contract', 'traffic_catalog', 'client_owned_catalog'].includes(selectedTab) && (
            <>
              {selectedTab !== 'in_stock_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'in_stock_catalog', name: 'In Stock Catalog' })}>
                  <ListItemIcon><span className="ic--sharp-move-up" /></ListItemIcon>
                  <ListItemText primary="Move to In Stock Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'client_owned_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'client_owned_catalog', name: 'Client Owned Catalog' })}>
                  <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
                  <ListItemText primary="Move to Client Owned Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'traffic_catalog' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'traffic_catalog', name: 'Traffic Catalog' })}>
                  <ListItemIcon><span className="material-symbols--moved-location-rounded" /></ListItemIcon>
                  <ListItemText primary="Move to Traffic Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'sub_contract' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'sub_contract', name: 'Sub Contract' })}>
                  <ListItemIcon><span className="hugeicons--square-arrow-move-right-up" /></ListItemIcon>
                  <ListItemText primary="Move to Sub Contract" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
              {selectedTab !== 'in_house' && (
                <MenuItem onClick={() => setMoveTarget({ id, target: 'in_house', name: 'Production Catalog' })}>
                  <ListItemIcon><span className="ic--outline-move-down" /></ListItemIcon>
                  <ListItemText primary="Move to Production Catalog" primaryTypographyProps={{ variant: 'body2' }} />
                </MenuItem>
              )}
            </>
          )}

          </>
        }
      </Menu>

    {/* Confirmation for deleting product  */}
    <ConfirmationPopup 
      open={openDeletePop}
      handleClose={()=>{setOpenDeletePop(false)}}
      message={`You want to delete ${userName} ! `}
      handleClick={()=>{handleMenuItemClick(id, 2)}}
    />

    <ConfirmationPopup
      open={!!moveTarget}
      handleClose={() => setMoveTarget(null)}
      message={`Are you sure you want to move "${userName}" to ${moveTarget?.name}?`}
      handleClick={() => {
        handleMove(moveTarget.id, moveTarget.target);
        setMoveTarget(null);
      }}
    />

    </>
  );
}
